(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mervaux-inquiry-context"] && !Shopify.designMode) return;
  try {
    class MervauxInquiryContext extends HTMLElement {
    connectedCallback() {
      const params = new URLSearchParams(window.location.search);
      const kind = params.get('inquiry');
      if (!['similar-piece', 'product-question'].includes(kind)) return;
      const product = (params.get('product') || '').trim().slice(0, 300);
      const sku = (params.get('sku') || '').trim().slice(0, 120);
      const productPath = params.get('product_url') || '';
      if (!product || !productPath.startsWith('/products/')) return;
      const productUrl = new URL(productPath, window.location.origin);
      if (productUrl.origin !== window.location.origin || !productUrl.pathname.startsWith('/products/')) return;
      const form = this.closest('form');
      if (!form) return;
      const request = kind === 'similar-piece' ? this.dataset.similar : this.dataset.question;
      this.querySelector('[data-inquiry-product]').textContent = product;
      const skuLabel = this.querySelector('[data-inquiry-sku]');
      skuLabel.textContent = sku ? `${this.dataset.skuLabel}: ${sku}` : '';
      skuLabel.hidden = !sku;
      this.querySelector('[data-inquiry-link]').href = productUrl.href;
      for (const [selector, value] of [
        ['[data-inquiry-type-field]', request],
        ['[data-inquiry-product-field]', product],
        ['[data-inquiry-sku-field]', sku],
        ['[data-inquiry-url-field]', productUrl.href],
      ]) {
        const field = this.querySelector(selector);
        field.value = value;
        field.disabled = false;
      }
      const message = form.querySelector('textarea[name="contact[body]"]');
      if (message && !message.value.trim()) {
        message.value = [request, `${this.dataset.productLabel}: ${product}`, sku ? `${this.dataset.skuLabel}: ${sku}` : '', productUrl.href, '', this.dataset.prompt].filter((line, index) => line || index === 4).join('\n');
      }
      this.hidden = false;
      if (window.location.hash === '#mervaux-inquiry') requestAnimationFrame(() => this.scrollIntoView({ block: 'start' }));
    }
  }
  if (!customElements.get('mervaux-inquiry-context')) customElements.define('mervaux-inquiry-context', MervauxInquiryContext);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mervaux-island-story"] && !Shopify.designMode) return;
  try {
    (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!('IntersectionObserver' in window)) return;
    const initialize = (scope) => {
      scope.querySelectorAll('[data-island-story]').forEach((chapter) => {
        if (chapter.dataset.travelMotionReady) return;
        chapter.dataset.travelMotionReady = 'true';
        if (reduced.matches) return;
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          if (reduced.matches || !chapter.animate) return;
          const figure = chapter.querySelector('.mervaux-island-story__figure');
          const copy = chapter.querySelector('.mervaux-island-story__copy');
          const animations = [];
          const compactMotion = window.matchMedia('(max-width:989px), (pointer:coarse)').matches;
          const offset = compactMotion ? 0 : (chapter.classList.contains('mervaux-island-interlude--reverse') ? 12 : -12);
          if (figure?.animate) animations.push(figure.animate([
            { opacity:.3, transform:`translateX(${offset}px)` },
            { opacity:1, transform:'translateX(0)' }
          ], { duration:1100, easing:'cubic-bezier(.22,1,.36,1)' }));
          if (copy) [...copy.children].forEach((element, index) => {
            if (!element.animate) return;
            animations.push(element.animate([
              { opacity:.2, transform:'translateY(12px)' },
              { opacity:1, transform:'translateY(0)' }
            ], { duration:850, delay:120 + index * 85, fill:'backwards', easing:'cubic-bezier(.22,1,.36,1)' }));
          });
          const stop = () => { if (reduced.matches) animations.forEach((animation) => animation.cancel()); };
          reduced.addEventListener('change', stop);
          Promise.allSettled(animations.map((animation) => animation.finished)).finally(() => reduced.removeEventListener('change', stop));
        }, { threshold:.08 });
        observer.observe(chapter);
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mervaux-mobile-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('.mervaux-mobile-menu__group')) return;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mervaux-order-requirements"] && !Shopify.designMode) return;
  try {
    class MervauxOrderRequirements extends HTMLElement {
    connectedCallback() {
      this.productForm = this.closest('product-form-component');
      this.onQuantity = () => this.syncQuantity();
      this.productForm?.addEventListener('input', this.onQuantity);
      this.productForm?.addEventListener('change', this.onQuantity);
      this.productForm?.addEventListener('quantity-selector:update', this.onQuantity);
      requestAnimationFrame(this.onQuantity);
    }
    disconnectedCallback() {
      this.productForm?.removeEventListener('input', this.onQuantity);
      this.productForm?.removeEventListener('change', this.onQuantity);
      this.productForm?.removeEventListener('quantity-selector:update', this.onQuantity);
    }
    syncQuantity() {
      const host = this.closest('product-form-component');
      if (!host || !['ready', 'preorder'].includes(this.dataset.baseState)) return;
      const input = host.querySelector('input[name="quantity"]');
      const quantity = Math.max(1, Number(input?.value) || 1);
      const cartQuantity = Math.max(0, Number(input?.dataset.cartQuantity) || 0);
      const ready = Math.max(0, Number(this.dataset.physicalStock) - cartQuantity);
      const exceedsStock = this.dataset.inventoryManaged === 'true' && this.dataset.inventoryPolicy === 'continue' && quantity > ready;
      const active = this.dataset.baseState === 'preorder' || (this.dataset.quantityPreorderEligible === 'true' && exceedsStock);
      const blocked = exceedsStock && this.dataset.quantityPreorderEligible !== 'true';
      const wasActive = this.dataset.orderRequirementsEnabled === 'true';
      this.dataset.orderRequirementsEnabled = String(active);
      this.hidden = !active;
      this.querySelector('fieldset').disabled = !active;
      if (active && !wasActive) this.querySelector('[data-requirement-consent]').checked = false;
      const readyQuantity = active ? Math.min(ready, quantity) : quantity;
      const preorderQuantity = active ? quantity - readyQuantity : 0;
      this.querySelector('[data-ready-quantity]').value = String(readyQuantity);
      this.querySelector('[data-preorder-quantity]').value = String(preorderQuantity);
      this.querySelector('[data-order-source]').value = Number(this.dataset.physicalStock) > 0 ? 'quantity' : 'made-to-order';
      const split = this.querySelector('[data-quantity-split]');
      split.textContent = (this.dataset.quantityCopy || '').replace('__READY__', String(readyQuantity)).replace('__PREORDER__', String(preorderQuantity));
      split.hidden = !active || readyQuantity <= 0 || preorderQuantity <= 0;
      host.dataset.mervauxState = blocked ? 'inquiry' : active ? 'preorder' : 'ready';
      host.dataset.mervauxPurchaseAllowed = String(!blocked);
      const notice = host.querySelector('[data-mervaux-purchase-notice]');
      if (notice) {
        notice.dataset.state = host.dataset.mervauxState;
        notice.replaceChildren();
        for (const text of [blocked ? this.dataset.inquiryLabel : active ? this.dataset.preorderLabel : this.dataset.readyLabel, active ? this.dataset.delivery : '']) {
          if (!text) continue;
          const paragraph = document.createElement('p');paragraph.textContent = text;notice.append(paragraph);
        }
      }
      const button = host.querySelector('button[name="add"]');
      if (button) {
        if (blocked) {button.disabled = true;button.dataset.mervauxQuantityBlocked = 'true';}
        else if (button.dataset.mervauxQuantityBlocked === 'true') {button.disabled = false;delete button.dataset.mervauxQuantityBlocked;}
        const text = Array.from(button.childNodes).find(node => node.nodeType === 3 && node.textContent.trim());
        if (text && !blocked) text.textContent = active ? this.dataset.preorderButton : this.dataset.readyButton;
      }
    }
    refreshFrom(next) {
      if (!next) {
        this.remove();
        return;
      }
      const sameProduct = this.dataset.productId === next.dataset.productId;
      const sameConsent = sameProduct && this.dataset.consentContext === next.dataset.consentContext;
      const values = new Map();
      if (sameProduct) this.querySelectorAll('[data-requirement-draft]').forEach(input => values.set(input.name, input.value));
      const wasAcknowledged = sameConsent && this.querySelector('[data-requirement-consent]')?.checked;
      for (const name of Object.keys(this.dataset)) delete this.dataset[name];
      Object.assign(this.dataset, next.dataset);
      this.hidden = next.hidden;
      this.innerHTML = next.innerHTML;
      this.querySelectorAll('[data-requirement-draft]').forEach(input => {
        if (values.has(input.name)) input.value = values.get(input.name);
      });
      const consent = this.querySelector('[data-requirement-consent]');
      if (consent) consent.checked = !!wasAcknowledged;
      this.syncQuantity();
    }
  }
  if (!customElements.get('mervaux-order-requirements')) customElements.define('mervaux-order-requirements', MervauxOrderRequirements);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mervaux-ring-size"] && !Shopify.designMode) return;
  try {
    class MervauxRingSize extends HTMLElement {
    connectedCallback() {
      if (!this.initialized) {
        this.initialized = true;
        this.addEventListener('change', event => {
          if (event.target.matches('[data-size-choice]')) this.syncSelection();
        });
        this.addEventListener('input', event => {
          if (event.target.matches('[data-requested-size]')) {
            event.target.setCustomValidity('');
            this.customSize = event.target.value;
            this.syncPresets();
          }
        });
        this.addEventListener('click', event => {
          const preset = event.target.closest('[data-size-preset]');
          if (!preset) return;
          const input = this.querySelector('[data-requested-size]');
          if (!input) return;
          input.value = preset.dataset.sizePreset;
          input.dispatchEvent(new Event('input', {bubbles: true}));
        });
      }
      this.syncSelection();
    }
    selectedChoice() { return this.querySelector('[data-size-choice]:checked')?.value || ''; }
    syncPresets() {
      const value = this.querySelector('[data-requested-size]')?.value;
      this.querySelectorAll('[data-size-preset]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sizePreset === value)));
    }
    syncSelection() {
      const input = this.querySelector('[data-requested-size]');
      if (!input) return;
      const choice = this.selectedChoice();
      const useReference = choice === 'Reference size';
      if (this.previousChoice === 'Request another size' && useReference) this.customSize = input.value;
      input.readOnly = useReference;
      input.required = choice === 'Request another size';
      input.setAttribute('aria-required', String(input.required));
      if (useReference) input.value = this.referenceNumber();
      else if (this.previousChoice === 'Reference size') input.value = this.customSize || '';
      input.setCustomValidity('');
      this.querySelectorAll('[data-size-choice]').forEach(radio => radio.setCustomValidity(''));
      const group = this.querySelector('[data-size-request]');
      if (group) group.hidden = choice !== 'Request another size';
      this.previousChoice = choice;
      this.syncPresets();
    }
    referenceNumber() {
      const match = (this.dataset.referenceSize || '').trim().match(/^US\s*([0-9]+(?:\.[0-9]+)?)(?:\s*\([^)]*\))?$/i);
      return match && Number.isFinite(Number(match[1])) && Number(match[1]) > 0 ? match[1] : '';
    }
    prepareForSubmit() {
      if (this.dataset.sizingEnabled !== 'true') return true;
      const input = this.querySelector('[data-requested-size]');
      if (!input) return false;
      this.syncSelection();
      input.value = input.value.trim();
      const choice = this.querySelector('[data-size-choice]:checked');
      if (choice?.value === 'Reference size' && !this.referenceNumber()) choice.setCustomValidity(this.dataset.referenceUnavailable);
      if (input.value && (!/^[0-9]+(?:\.[0-9]+)?$/.test(input.value) || !Number.isFinite(Number(input.value)) || Number(input.value) <= 0)) input.setCustomValidity(this.dataset.invalidSize || 'Enter a US ring size.');
      return true;
    }
    refreshFrom(next) {
      if (!next) { this.remove(); return; }
      const sameProduct = this.dataset.productId === next.dataset.productId;
      const previousSelection = this.selectedChoice() || this.retainedSelection || '';
      const previousValue = this.querySelector('[data-requested-size]')?.value || this.retainedValue || '';
      const customSize = this.customSize || '';
      for (const name of Object.keys(this.dataset)) delete this.dataset[name];
      Object.assign(this.dataset, next.dataset);
      this.hidden = next.hidden;
      this.innerHTML = next.innerHTML;
      this.previousChoice = '';
      this.customSize = sameProduct ? customSize : '';
      this.retainedSelection = sameProduct ? previousSelection : '';
      this.retainedValue = sameProduct ? previousValue : '';
      if (sameProduct) {
        this.querySelectorAll('[data-size-choice]').forEach(radio => { radio.checked = radio.value === previousSelection; });
        const input = this.querySelector('[data-requested-size]');
        if (input && previousSelection === 'Request another size') input.value = previousValue;
      }
      this.syncSelection();
    }
  }
  if (!customElements.get('mervaux-ring-size')) customElements.define('mervaux-ring-size', MervauxRingSize);
  } catch(e) { console.error(e); }
})();

})();
